export default {
  setCourses(state, courses) {
    state.courses = courses;
  },
  setCourse(state, course) {
    state.course = course;
    state.course.lessons.sort((a, b) => {
      if (a.module == null && b.module == null) return a.number - b.number;
      if (a.module == null && b.module != null) return -1;
      if (a.module != null && b.module == null) return 1;
      if (a.module.order > b.module.order) return 1;
      if (a.module.order < b.module.order) return -1;
      return a.number - b.number;
    });
  },
  setLastLessons(state, lastLessons) {
    state.lastLessons = lastLessons;
  }
};
